import { render, staticRenderFns } from "./SeniorDashboard.vue?vue&type=template&id=236a4958"
import script from "./SeniorDashboard.vue?vue&type=script&lang=ts"
export * from "./SeniorDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports